import React from 'react';

// services

import PropTypes from 'prop-types';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

import {
  Wrapper,
  Logo,
  Button,
  Content,
  BannerText,
  ShapeContainer,
  CircleShape,
  TextButton
} from './styles';

import combinedShapeImg from '../../../../../assets/images/combinedShape.svg';

const BonusJourneyBannerTemp = ({
  image,
  bannerText,
  bannerBoldWords,
  redirectTo,
  circleShapeVisible,
  bannerTextButton,
  buttonVisible
}) => {
  const updateTextWithBoldWords = () => {
    let bannerBoldWordsIndex = 0;
    return (
      <BannerText>
        {bannerText.split(' ').map(item => {
          let updatedText;

          if (item === '%STRONG%' && bannerBoldWords) {
            updatedText = (
              <strong>{`${bannerBoldWords[bannerBoldWordsIndex]} `}</strong>
            );
            bannerBoldWordsIndex += 1;
          } else {
            updatedText = `${item} `;
          }

          return updatedText;
        })}
      </BannerText>
    );
  };
  function handleOpenLink() {
    if (redirectTo === 'BonusJourneyDashboard') {
      window.location = getSessionItem('PLATAFORMA_ESCALADA');
    } else {
      window.open(redirectTo, '_blank');
    }
  }
  return (
    <Wrapper data-testid="banner-bonus-journey">
      <Logo
        src={image}
        data-testid="banner-bonus-journey-image"
        alt="Logo - Jornada de Bônus"
      />
      <Content>
        {updateTextWithBoldWords()}
        {buttonVisible && (
          <Button
            variant="outlined"
            disable={false}
            data-testid="banner-bonus-journey-cta"
            onClick={() => handleOpenLink()}
          >
            <TextButton>{bannerTextButton}</TextButton>
          </Button>
        )}
      </Content>

      <ShapeContainer>
        {circleShapeVisible && <CircleShape src={combinedShapeImg} />}
      </ShapeContainer>
    </Wrapper>
  );
};

export default BonusJourneyBannerTemp;

BonusJourneyBannerTemp.propTypes = {
  image: PropTypes.string.isRequired,
  bannerText: PropTypes.string.isRequired,
  bannerBoldWords: PropTypes.arrayOf(PropTypes.string),
  redirectTo: PropTypes.string.isRequired,
  circleShapeVisible: PropTypes.bool.isRequired,
  bannerTextButton: PropTypes.string.isRequired,
  buttonVisible: PropTypes.bool
};

BonusJourneyBannerTemp.defaultProps = {
  bannerBoldWords: [],
  buttonVisible: true
};
